import { useBannerControllerGetBanner } from '@/generated/api/banner.ts';

export default function useBannerAlert({
  enabled = true,
}: { enabled?: boolean } = {}) {
  const query = useBannerControllerGetBanner({
    query: {
      enabled,
      staleTime: 60_000,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
  });

  return {
    active: query.data?.active ?? false,
    severity: query.data?.severity ?? 'INFO',
    message: query.data?.message ?? '',
  };
}
